import { render, staticRenderFns } from "./NeedsDashboard.vue?vue&type=template&id=b497b3be&scoped=true&"
import script from "./NeedsDashboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsDashboard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b497b3be",
  null
  
)

export default component.exports